// @flow
import React, { PureComponent } from 'react';
import SideBillboardCard from 'components/billboard/SideBillboardCard';
// import CountDownHome from 'components/billboard/CountDownHome';
import BillboardHeader from 'components/billboard/BillboardHeader';
import JoinStories from 'components/fragments/JoinStories';
import EventDrivenPageBanner from 'components/header/EventDrivenPageBanner';
import EventDrivenPagePromotionalBlock from 'containers/billboard/EventDrivenPagePromotionalBlockContainer';
import HubTrouverRugby from 'containers/hubtrouverrugby/HubTrouverRugbyContainer';
import ClubFinderHubContainer from 'containers/club/ClubFinderHubContainer';
import HubEntreprise from 'containers/hubentreprise/HubEntrepriseContainer';
import FidInscription from 'containers/profile/Fidelite/fidInscription';
import SocialHubContainer from 'containers/social/SocialHubContainer';
import TeamMenuContainer from 'containers/teammenu/TeamMenuContainer';
import FFRtvHubContainer from 'containers/ffrtv/FFRtvHubContainer';
import PushEventContainer from 'containers/pushevent/PushEventContainer';
import ParticipateContainer from 'containers/hub/ParticipateContainer';
import type { Status } from 'types/Status';
import type { CategoryArticleType, ArticleType } from 'types/Article';
import type { CompetitionsInternationalesLink } from 'types/competitionsInternationales';
import type { RouterProps } from 'types/Router';
import type { FullUserType } from 'types/User';
import { withHelmet } from 'infrastructure/seo/Helmet';

export type StateProps = {
  categoriesArticle: CategoryArticleType[],
  current_competition: CompetitionsInternationalesLink,
  status: Status,
  description: string,
  title: string,
  keycloakData: any,
  userPref: FullUserType
};

export type DispatchProps = {
  fetchArticlesStaticCategories: () => void
};

type Props = StateProps & DispatchProps & RouterProps;

class Billboard extends PureComponent<Props> {
  componentDidMount() {
    this.props.fetchArticlesStaticCategories();
  }

  renderNews = (news: Array<ArticleType>): any => {
    const { userPref } = this.props;

    return news.map(actu => <SideBillboardCard key={actu.title} row={true} content={actu} userPref={userPref} />);
  };

  render() {
    const { current_competition, userPref } = this.props;

    return (
      <React.Fragment>
        <div className="display-desktop">
          <EventDrivenPageBanner current_competition={current_competition} location={this.props.location} />
        </div>
        <BillboardHeader categoriesArticle={this.props.categoriesArticle} />
        {/* <CountDownHome message={`La Coupe du Monde de Rugby 2023 commence dans `} date='2023-09-08T19:15:00Z'/> */}
        {userPref && userPref.email.includes('apsulis.io') && (
          <section className="container mt-7">
            <div className="row">
              <div className="col">
                <FidInscription doNotShowIfSubscribed={true} />
              </div>
            </div>
          </section>
        )}
        <PushEventContainer />
        <EventDrivenPagePromotionalBlock />
        <TeamMenuContainer />

        <section className="section section--white section--join-stories">
          <div className="container">
            <h3 className="ft-h2 mb-2">Destins mêlés</h3>
            <JoinStories
              styles={{
                '--join-widget-card-mobile-height': '325px',
                '--join-widget-card-desktop-height': '400px',
                margin: '5px 2px',
                minHeight: 'calc(var(--join-widget-card-mobile-height) + 30px)'
              }} // à voir !!!
              scriptSrc="https://ffr.my.join-stories.com/widgets/destins-meles/index.js"
              scriptWidgetId="list-card-destins-meles"
              scriptWidgetAlias="destins-meles"
            />{' '}
            <JoinStories
              styles={{
                '--join-widget-bubble-mobile-height': '75px',
                '--join-widget-bubble-desktop-height': '89px',
                margin: '5px 2px',
                minHeight: 'calc(var(--join-widget-bubble-mobile-height) + 39px)'
              }} // à voir !!!
              scriptSrc="https://ffr.my.join-stories.com/widgets/destins-meles-mobile/index.js"
              scriptWidgetId="list-bubble-destins-meles-mobile"
              scriptWidgetAlias="destins-meles-mobile"
            />
          </div>
        </section>

        <FFRtvHubContainer />
        <SocialHubContainer />
        <HubTrouverRugby />
        <ClubFinderHubContainer />
        <ParticipateContainer />
        <HubEntreprise />
      </React.Fragment>
    );
  }
}

export default withHelmet(Billboard)((Helmet, pageProps) => {
  const title = 'Fédération Française de Rugby - FFR';
  const description = `Retrouvez toute l'actualité et les résultats 
  des équipes de France de rugby et du rugby amateur 
  sur le site de la Fédération Française de Rugby`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name={'description'} content={description} />
      <meta property={'og:title'} content={title} />
      <meta property={'og:description'} content={description} />
      <meta
        property={'og:image'}
        content={'https://api.www.ffr.fr/wp-content/uploads/2019/02/Portail-FFR-Entre%CC%81e.jpg'}
      />
      <meta
        property={'og:image:url'}
        content={'https://api.www.ffr.fr/wp-content/uploads/2019/02/Portail-FFR-Entre%CC%81e.jpg'}
      />
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );
});
